// import {LuCopyright} from "react-icons/lu";
// import {Group, HStack, Link} from "@chakra-ui/react";
//
// function Footer() {
//     return (
//         <HStack padding={"10px"} bottom={0} position={"absolute"} width={"100%"} height={"5%"} alignItems="center" justifyContent="space-between" alignContent="center" className="agx__footer" backgroundColor={"#033642"}>
//             <Group>
//                 <LuCopyright /><p>Agxes Inc. All rights reserved.</p>
//             </Group>
//             <Group >
//                 <Link href="#">Privacy Policy</Link>
//                 <Link href="#">Terms of Service</Link>
//             </Group>
//         </HStack>
//     );
//
// }
//
// export default Footer;

import {LuCopyright} from "react-icons/lu";
import {HStack, Text, Box} from "@chakra-ui/react";

function DemoFooter() {
    return (
        <Box as="footer" width="100%" bg="#033642" py={3} color="white">
            <HStack justifyContent="space-between" maxW="1200px" mx="auto" px={4}>
                <HStack>
                    <LuCopyright/>
                    {/*SPANISH*/}
                    {/*<Text>Agxes Inc. Todos los derechos reservados.</Text>*/}
                    {/*ENGLISH*/}
                    <Text>Agxes Inc. All rights reserved.</Text>
                </HStack>
                {/*<HStack>*/}
                {/*    <Link href="#" px={4} color="white" _hover={{ textDecoration: "underline" }}>Privacy Policy</Link>*/}
                {/*    <Link href="#" color="white" _hover={{ textDecoration: "underline" }}>Terms of Service</Link>*/}
                {/*</HStack>*/}
            </HStack>
        </Box>
    );
}

export default DemoFooter;
